import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ModalResultsServicesService } from 'src/app/services/modal-results-services.service';

@Component({
  selector: 'app-upload-zip-rar-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './upload-zip-rar-modal.component.html',
  styleUrls: ['./upload-zip-rar-modal.component.scss'],
  
})
export class UploadZipRarModalComponent implements OnInit {
  fileName: string = '';
  showLoader: boolean = false;
  modelFor: string = '';
  isLargeFile: boolean = false;
  errorMessage: string = '';
  itemsdataref: any[] = [];
  subscription: Subscription | undefined;

  @Input() criteriaObj: any;
  file: File | null = null;

  @Input() apiName:string = "";

// progress tracking
  inProcessing = false;
  progress = 0;
  processed = 0;
  total = 0;
  currentFile = '';

  constructor(
    private common: CommonFunctionService,
    private ngbActiveModal: NgbActiveModal,
    public modalResult: ModalResultsServicesService,
    private commonApi: ApiRequestsService,
    private toaster: ToastrService,
    private loaderSer: LoaderService,
    private router: Router 
  ) {}

  ngOnInit(): void {
    console.log(this.modelFor, this.apiName);
    this.modalResult.itrZipJsonResult = [];
  }
  
  closeModal(closeOption: string = 'close'): void {
    this.showLoader = false;
    this.fileName = '';
    this.file = null;
    this.ngbActiveModal.close(closeOption);
  }
  
  validateFileFormat(): boolean {
    const fileType = this.fileName.toString().split('.').pop();
    if (fileType && ['zip','rar', 'pdf'].includes(fileType)) {
      return true;
    } else {
        this.errorMessage = 'Invalid file type is selected. Select Only (zip, rar, pdf) file.';
        return false;
    } 
  }

  createFormObjectForSubmit = (): FormData => {
    let formData: FormData = new FormData();
    if(this.file) {
      formData.append("UploadFile", this.file, this.fileName);
      formData.append("UploadFile", this.fileName.split('.')[0]);
    }
    return formData;
  }

  onFileChange(event: any): void {
    this.file = event.target.files[0] as File;
    this.fileName = this.file ? this.file.name : '';
    if (!this.validateFileFormat()) return;
    this.common.uploadedFileName = this.fileName;
    const formData = this.createFormObjectForSubmit();
    this.showLoader = true;
    this.errorMessage = "";
    this.commonApi.uploadFile(this.file, this.apiName, { localPath: this.fileName.split('.')[0], servingHubLocationId: this.common.servivngLocationId}).subscribe(async (res: any) => {
      this.showLoader = false;
      if (res['errorCode'] != this.commonApi.NO_ERROR) {
        this.errorMessage = res['errorDescription'];
        this.fileName = "";
        this.file = null;
        return;
      }
      // this.loaderSer.showProcessingToaster(`Processing ${res['totalFiles']} file`)
      this.common.CreateObjectForFilesToProcess(res);
      this.showLoader = false;
      this.fileName = '';
      this.file = null;
      this.ngbActiveModal.close({
          totalFiles: res['totalFiles'],
          res,
        });
      
      });
  }
 
}
